var _rect, _rect2, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 35,
    viewBox: "0 0 32 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.8135,
    y: 0.144104,
    width: 15.1864,
    height: 10.3051,
    fill: "#7C3AED"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 24.5508,
    width: 15.1864,
    height: 10.3051,
    fill: "#7C3AED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.55082C0 3.90789 3.76384 0.144043 8.40678 0.144043H15.1864V16.9576H8.40679C3.76385 16.9576 0 13.1938 0 8.55082Z",
    fill: "#7C3AED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 26.4491C32 21.8062 28.2362 18.0424 23.5932 18.0424H16.8136V34.8559H23.5932C28.2362 34.8559 32 31.0921 32 26.4491Z",
    fill: "#7C3AED"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d893bbd0ef79170d02d94d2d9cbe5004.svg";
export { ForwardRef as ReactComponent };